import { useEffect } from 'react';

// Réserve, côté en-tête, la même largeur que prend la scrollbar verticale du conteneur partagé
// (colonne de noms + corps) : sans ça, l'en-tête et le corps n'ont pas la même largeur de
// défilement horizontal et un même scrollLeft ne pointe plus sur le même jour des deux côtés.
export function useTimelineHeaderScrollbarGap({ timelineHeaderScrollRef, timelineScrollRef }) {
  useEffect(() => {
    const el = timelineScrollRef.current,
      header = timelineHeaderScrollRef.current;
    if (!el || !header) return;
    const sbw = el.offsetWidth - el.clientWidth;
    header.style.marginRight = sbw > 0 ? sbw + 'px' : '0px';
  });
}
